var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7129_13114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.30005 19V41.5H39.3V19",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 32.5C16.8 29.1863 19.4863 26.5 22.8 26.5V26.5C26.1138 26.5 28.8 29.1863 28.8 32.5V41.5H16.8V32.5Z",
    stroke: "black",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.80005 23.5L22.8 2.5L43.8 23.5",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7129_13114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0.800049 0.5)"
  })))));
};

export default SvgHome;